import { Box, FormHelperText, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import Iconify from '../Iconify';
import { parseVideoLink, VIDEO_PROVIDER_LABELS } from '../../utils/videoSource';
import '../../css/users/addUserDialog.css';

/**
 * Canonical file-or-link picker for every module (articles, machines, …).
 * Do not fork this control. Limits and dropzone content are props / children.
 */
const VideoSourceFields = ({
    sourceKind,
    onSourceKindChange,
    url,
    onUrlChange,
    fileHint,
    children,
}) => {
    const parsed = sourceKind === 'link' ? parseVideoLink(url) : null;

    return (
        <Box sx={{ width: '100%' }}>
            <ToggleButtonGroup
                exclusive
                fullWidth
                size="small"
                value={sourceKind}
                onChange={(event, value) => value && onSourceKindChange(value)}
                sx={{ mb: 2 }}
            >
                <ToggleButton value="upload" sx={{ textTransform: 'none', fontFamily: 'Mulish' }}>
                    <Iconify icon="material-symbols:upload" sx={{ mr: 0.5 }} />
                    Fichier vidéo
                </ToggleButton>
                <ToggleButton value="link" sx={{ textTransform: 'none', fontFamily: 'Mulish' }}>
                    <Iconify icon="material-symbols:link" sx={{ mr: 0.5 }} />
                    Lien en ligne
                </ToggleButton>
            </ToggleButtonGroup>

            {sourceKind === 'link' ? (
                <Box className="addUser_helper_selct_box">
                    <FormHelperText className="addUserInputTitle">Adresse de la vidéo</FormHelperText>
                    <TextField
                        fullWidth
                        className="addUser_InputField"
                        placeholder="https://www.youtube.com/watch?v=…"
                        value={url}
                        onChange={(event) => onUrlChange(event.target.value)}
                        error={Boolean(url) && !parsed}
                    />
                    <FormHelperText error={Boolean(url) && !parsed}>
                        {url && !parsed
                            ? 'Lien non reconnu. Plateformes acceptées : YouTube, Vimeo, Dailymotion, ou lien direct vers un fichier vidéo.'
                            : 'Collez l’adresse de la page (YouTube, Vimeo, Dailymotion) ou un lien direct.'}
                    </FormHelperText>
                    {parsed && (
                        <Typography sx={{ fontFamily: 'Mulish', fontSize: '0.85rem', mt: 1, color: '#2E7D32' }}>
                            Plateforme reconnue : {VIDEO_PROVIDER_LABELS[parsed.provider]}
                        </Typography>
                    )}
                </Box>
            ) : (
                children
            )}

            {sourceKind === 'upload' && fileHint ? (
                <Typography sx={{ fontFamily: 'Mulish', fontSize: '0.8rem', color: '#6E6D6D', mt: 1 }}>
                    {fileHint}
                </Typography>
            ) : null}
        </Box>
    );
};

export default VideoSourceFields;
